import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Mõõtmed

  <span style="color:#85c1dc;">**FI:**</span>
  Mitat

  <span style="color:#85c1dc;">**RU:**</span>
  Размеры
*/
/* @__NO_SIDE_EFFECTS__ */
const m1722 = msg(
  mf`Mõõtmed`,
  mf`Mitat`,
  mf`Размеры`,
)

export { m1722 as 'w.module.image_viewer.measurements' }